import { Field, Form } from 'react-final-form'

import Button from 'common/components/button'
import FormItem from 'common/components/FormItem'
import Input from 'common/components/Input'
import PageHeader from 'common/components/PageHeader'
import PageTitle from 'common/components/PageTitle'
import SingleSelect from 'common/components/singleSelect'
import Spinner from 'common/components/spinner'
import Page from 'features/personalization/components/Page'

import useGetRecommendationMutation from './api/mutations/useGetRecommendationMutation'

const headers = [
  'productivity_software',
  'computer_software',
  'computing',
  'washer_dryers',
  'air_purifiers',
  'electric_blankets',
  'gift_cards',
  'computing_accessories',
  'ipad',
  'mens_grooming',
  'e_readers',
  'electronics',
  'car_accessories',
  'outdoor_lighting',
  'printers',
  'laptops',
  'mobile_devices',
  'power_tools',
  'mini_ovens',
  'irons',
  'sat_nav',
  'home_appliances',
  'printer_paper',
  'hair_removal',
  'label_makers',
  'kitchen_mixers',
  'washing_machines',
  'audio',
  'gaming_accessories',
  'headphones',
  'food_and_drink_storage',
  'projectors',
  'mobile_phones',
  'c_vitamins',
  'smart_watches',
  'cameras',
  'tvs',
  'microsoft_office',
  'horror_games',
  'sports_games',
  'food_processors',
  'desktop_pc',
  'photography_accessories',
  'health_and_beauty_appliances',
  'preschool_electronic_toys',
  'health_and_wellbeing_tech',
  'fitness_tech',
  'phone_cases',
  'phones',
  'tablets',
  'consoles',
  'pc_parts',
  'cleaning_appliances',
  'hard_drives',
  'computer_keyboards',
  'air_treatment',
  'wearable_tech',
  'dehumidifiers',
  'monitors',
  'portable_speakers',
  'photography_bags',
  'cooking_appliances',
  'gaming',
  'memory_cards',
  'exercise_equipment',
  'coffee_machines',
  'smart_security',
  'dishwashers',
  'pots_and_pans',
  'entertainment',
  'mobile_accessories',
  'photography',
  'tumble_dryers',
  'computer_mice',
  'office_supplies',
  'freezers',
  'fridges',
  'laundry',
  'fridge_freezers',
  'computers',
  'gardening',
  'editing_software',
  'games',
  'rice_cookers',
  'smart_home_tech',
  'controllers',
  'fitness_trackers',
].sort((a, b) => a.localeCompare(b))

const DemoPage = () => {
  const mutation = useGetRecommendationMutation()
  return (
    <Page className="lg:px-40 px-6 pt-6 ">
      <div className="flex flex-col w-full h-full bg-warmGray-50 max-w-screen-lg sm:mx-auto">
        <PageHeader>
          <PageTitle title="Recommendation" />
        </PageHeader>

        <Spinner isSpinning={mutation.isLoading}>
          <Form<{ productCategory: string; productName: string | undefined }>
            initialValues={{
              productCategory: headers[0],
            }}
            keepDirtyOnReinitialize
            onSubmit={(values) => {
              mutation.mutate(values)
            }}
            render={({ handleSubmit }) => (
              <form
                className="px-6 pt-12 lg:pt-8 bg-white pb-6"
                onSubmit={handleSubmit}
              >
                <Field<string>
                  name="productCategory"
                  render={({ input, meta }) => (
                    <FormItem
                      label="Select the category for this triggered email"
                      htmlFor="productCategory"
                      className="max-w-75"
                      error={meta.error}
                    >
                      <SingleSelect
                        id="productCategory"
                        onChange={(val) => input.onChange(val?.value)}
                        value={input.value}
                        isSearchable={true}
                        required
                        options={headers.map((value) => ({
                          label: value,
                          value,
                        }))}
                      />
                    </FormItem>
                  )}
                />
                <Field<string> name="productName">
                  {({ input, meta }) => (
                    <FormItem
                      label="Enter the product name (if available)"
                      error={meta.touched ? meta.error : undefined}
                      className="flex-none mr-6"
                    >
                      <Input
                        type="text"
                        variant="default"
                        className="bg-white max-w-sm"
                        value={input.value}
                        onChange={input.onChange}
                      />
                    </FormItem>
                  )}
                </Field>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={mutation.isLoading}
                >
                  Make recommendation
                </Button>
              </form>
            )}
          />
          {mutation.data && (
            <div className="my-6 py-6 pl-6 bg-white gap-6 flex flex-col">
              <div className="text-xl font-semibold">Selected variant:</div>
              <div className="text-2xl font-semibold">
                {mutation.data.variant_text}
              </div>
            </div>
          )}
        </Spinner>
      </div>
    </Page>
  )
}

export default DemoPage
